"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSignal = function SvgIconSignal(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "signal icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Signal Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.292 36.854a5.146 5.146 0 11-10.292 0 5.146 5.146 0 0110.292 0zm14.116 3.797c-.672-12.424-10.622-22.387-23.059-23.059A1.284 1.284 0 006 18.877v3.863c0 .676.522 1.243 1.196 1.287 8.987.586 16.19 7.771 16.777 16.777A1.287 1.287 0 0025.26 42h3.862c.736 0 1.325-.615 1.286-1.35zm11.591.023C41.325 21.884 26.207 6.679 7.326 6A1.285 1.285 0 006 7.287v3.863c0 .693.55 1.257 1.242 1.285 15.362.63 27.693 12.963 28.323 28.323A1.29 1.29 0 0036.85 42h3.863c.726 0 1.312-.6 1.286-1.326z"
  }));
};

var _default = SvgIconSignal;
exports.default = _default;